export default defineNuxtRouteMiddleware((to) => {

  if (process.server) return

  const { isAuthenticated, hasPermission, isAdmin } = useAuthStorage()

  if (!isAuthenticated()) {
    return navigateTo('/authenticate')
  }

  const requiredPermissions = to.meta.permissions as {
    especialidade?: string
    action?: 'visualizar' | 'inserir' | 'editar' | 'excluir'
    requireAdmin?: boolean
  }

  if (!requiredPermissions) {
    return
  }

  if (requiredPermissions.requireAdmin && !isAdmin()) {
    return navigateTo('/unauthorized')
  }

  if (requiredPermissions.especialidade && requiredPermissions.action) {
    const hasRequiredPermission = hasPermission(
      requiredPermissions.especialidade,
      requiredPermissions.action
    )

    if (!hasRequiredPermission) {
      return navigateTo('/unauthorized')
    }
  }
}) 